import { HttpClient, HttpHeaders, HttpRequest } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from '../../../environments/environment';
import { LanguageService } from 'src/app/services/language.service';
import { LanguageEnum } from 'src/app/shared/models/item.model';

@Injectable({
  providedIn: 'root',
})
export class ApiClientService {
  private apiUrl: string = environment.apiUrl;

  constructor(private http: HttpClient, private langService: LanguageService) {
    this.setLanguage();
  }

  setLanguage(): void {
    environment.header.headers['Accept-Language'] =
      this.langService.getCurrentLanguage() === LanguageEnum.ar ? 'ar-SA' : 'en-US';
    this.langService.languageChange.subscribe((result: LanguageEnum) => {
      environment.header.headers['Accept-Language'] = result === LanguageEnum.ar;
    });
  }

  public get(route: string): any {
    return this.http.get(this.createCompleteRoute(route), this.headers);
  }

  public create(route: string, body: any): any {
    let headers = { ...this.headers.headers };
    if (body instanceof FormData) delete headers['Content-Type'];

    return this.http.post(this.createCompleteRoute(route), body, {headers});
  }

  public postExternal(endpoint: string, body:any) {
    return this.http.post(endpoint, body);
  }

  public update(route: string, body: any, id?: number): any {
    let url = this.createCompleteRoute(route);
    if (id) {
      url += '/' + id;
    }
    let headers = { ...this.headers.headers };
    if (body instanceof FormData) delete headers['Content-Type'];

    return this.http.put(url, body, { headers });
  }

  public delete(id: number, route: string): any {
    return this.http.delete(`${this.createCompleteRoute(route)}/${id}`, this.headers);
  }

  createCompleteRoute(route: string): any {
    const middlePath = this.apiUrl.split('').pop() !== '/' && route !== null && route[0] !== '/' ? '/' : '';
    return `${this.apiUrl}${middlePath}${route}`;
  }

  public customRequest(
    method: 'GET' | 'POST' | 'PUT' | 'DELETE',
    route: string,
    body: any,
    reportProgress: boolean = false,
    responseType?: 'arraybuffer' | 'blob' | 'json' | 'text',
  ) {
    let customHeader = new HttpHeaders();
    customHeader = customHeader.set('Authorization', `Bearer ${localStorage.getItem('token')}`);
    const req = new HttpRequest(method, this.createCompleteRoute(route), body, {
      reportProgress: reportProgress,
      responseType: responseType,
      withCredentials: environment.allowCredentials,
      headers: customHeader
    });

    return this.http.request(req);
  }

  get headers() {
    let auth = environment.header.headers["Authorization"];
    if (!auth && localStorage.getItem('token')) {
      environment.header.headers['Authorization'] = `Bearer ${localStorage.getItem('token')}`;
    }
    return environment.header;
  }
}
